import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { FiArrowLeftCircle as IconArrow } from 'react-icons/fi'
import theme from '../../lib/theme'
import colors from '../../lib/colors'

const StyledDiv = styled.div`
  min-height: ${theme.footerHeight};
  padding: 8px;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  background: linear-gradient(
    15deg,
    ${(props): string => props.theme.secondaryColor} 0%,
    ${(props): string => props.theme.primaryColor} 60%
  );
  &.menu-control-closed {
    .menu-arrow {
      transform: rotate(180deg);
      :hover {
        transform: rotate(180deg) scale(1.1);
      }
    }
  }
  .menu-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s;
    cursor: pointer;
    color: ${colors.white};
    svg {
      width: 30px;
      height: auto;
    }
    :hover {
      transform: scale(1.1);
    }
  }
`
interface MenuControlProps {
  primaryColor?: string
  secondaryColor?: string
  toggleMenu: () => void
  menuCollapsed: boolean
}
export default function MenuControl({
  primaryColor,
  secondaryColor,
  toggleMenu,
  menuCollapsed,
}: MenuControlProps): ReactElement {
  return (
    <StyledDiv
      onClick={toggleMenu}
      className={menuCollapsed ? 'menu-control-closed' : ''}
      theme={{ primaryColor, secondaryColor }}
    >
      <div className="menu-arrow">
        <IconArrow />
      </div>
    </StyledDiv>
  )
}
